(() => {
  'use strict';
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches || document.documentElement.classList.contains('p26-motion-paused') || document.body.classList.contains('p26-motion-paused');
  document.querySelectorAll('[data-award-cabinet]').forEach(cabinet => {
    const track = cabinet.querySelector('.cr-cabinet-track');
    const prev = cabinet.querySelector('[data-cabinet-prev]');
    const next = cabinet.querySelector('[data-cabinet-next]');
    const status = cabinet.querySelector('[data-cabinet-status]');
    const cards = [...track.querySelectorAll('.cr-cabinet-award')];
    const update = () => {
      if (!track.clientWidth) return;
      const box = track.getBoundingClientRect();
      const visible = cards.map((c,i) => ({i,box:c.getBoundingClientRect()})).filter(c => c.box.left >= box.left - 5 && c.box.right <= box.right + 5);
      prev.disabled = track.scrollLeft <= 3;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 3;
      if (visible.length) status.textContent = `${visible[0].i + 1}–${visible[visible.length-1].i + 1} of ${cards.length} award displays`;
    };
    const move = dir => { const gap = parseFloat(getComputedStyle(track).columnGap) || 14; const width = cards[0].getBoundingClientRect().width + gap; const cols = Math.max(1, Math.round(track.clientWidth / width)); track.scrollBy({left:dir * width * cols,behavior:reduced()?'instant':'smooth'}); };
    prev.addEventListener('click',()=>move(-1));
    next.addEventListener('click',()=>move(1));
    track.addEventListener('keydown', event => { if (event.target !== track) return; if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {event.preventDefault();move(event.key === 'ArrowRight'?1:-1);} });
    let frame;
    track.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(update);},{passive:true});
    new ResizeObserver(update).observe(track);
    update();
  });
})();
